// This is the group ID for watchful,
export const MAIN_ATTRIBUTE_QUALITY_GROUP_ID = 1;

// It's important that main attributes appear on the 'Myself' tab in this order
export const MAIN_ATTRIBUTES = [
  'Watchful',
  'Shadowy',
  'Dangerous',
  'Persuasive',
];